//TODO: Wrap routes with 'Loadable'
import { lazy } from 'react';
import Loadable from 'ui-component/Loadable';
import { UserRole } from 'Application/models';
import {
    BritamAdminAgencies,
    BritamAdminAgency,
    BritamAdminHome,
    BritamAdminSupport,
    TravelPlanBenefits,
    TravelSetup
} from 'Application/pages';
import UsersManagement from 'Application/pages/TravelPortal/Dashboard/Britam/BritamAdmin/Users/Users/index';
import { AdminCompletedTransactions } from 'Application/pages/TravelPortal/Dashboard/Britam/Shared/CompletedTransactions/index';
import AdminViewPolicy from 'Application/pages/TravelPortal/Dashboard/Britam/Shared/CompletedTransactions/ViewPolicy';
import RwandaAdminViewPolicy from 'Application/pages/TravelPortal/Dashboard/Britam/Shared/CompletedTransactions/ViewPolicyRwanda';

const GenerateQuote = Loadable(lazy(() => import('Application/pages/TravelPortal/Dashboard/shared/Quotes/Kenya/GenerateQuote/index')));
const GenerateQuoteRwanda = Loadable(
    lazy(() => import('Application/pages/TravelPortal/Dashboard/shared/Quotes/Rwanda/GenerateQuote/index'))
);

const Quotes = Loadable(
    lazy(() =>
        import('Application/pages/TravelPortal/Dashboard/Britam/Shared/Quotes').then((module) => ({
            default: module.AgencyUserGeneratedQuotes
        }))
    )
);
const CompletedQuote = Loadable(
    lazy(() =>
        import('Application/pages/TravelPortal/Dashboard/shared/Quotes/Kenya/CompletedTransactions/index').then((module) => ({
            default: module.AgencyUserCompletedTransactions
        }))
    )
);
const SelfPolicies = Loadable(
    lazy(() =>
        import('Application/pages/TravelPortal/Dashboard/Britam/Shared/SelfCompletedTransactions').then((module) => ({
            default: module.AdminCompletedTransactions
        }))
    )
);
const Settings = Loadable(lazy(() => import('Application/pages/TravelPortal/Dashboard/shared/Settings/index')));

import MainLayout from 'layout/MainLayout';
import { ProtectedRoute } from './ProtectedRoute';
import ViewQuoteDetails from 'Application/pages/TravelPortal/Dashboard/Britam/Shared/Quotes/ViewQuotation/ViewQuoteDetails';
// import CorporateManagement from 'Application/pages/TravelPortal/Dashboard/Britam/BritamAdmin/BritamAdminAgencies/Corporate';

export const BritamAdminRoutes = {
    path: '/britam-admin',
    element: (
        <ProtectedRoute
            component={<MainLayout />}
            requiredRoles={[UserRole.ROLE_ADMINISTRATOR, UserRole.ROLE_UNDER_WRITER, UserRole.ROLE_REGIONAL_ADMIN]}
        />
    ),
    children: [
        //TODO: Add Britam admin routes
        {
            path: 'home',
            element: <BritamAdminHome />
        },
        {
            path: 'travel-portal',
            children: [
                {
                    path: 'completed-transactions',
                    children: [
                        {
                            path: '',
                            element: <SelfPolicies />
                        },
                        {
                            path: 'viewpolicy',
                            element: <AdminViewPolicy />
                        },
                        {
                            path: 'viewpolicy/:policyNumber', // Add :policyNumber to make it dynamic
                            element: <AdminViewPolicy />
                        },
                        {
                            path: 'viewpolicy-kyc-rw',
                            element: <RwandaAdminViewPolicy />
                        },
                        {
                            path: 'viewpolicy-kyc-rw/:policyNumber', // Add :policyNumber to make it dynamic
                            element: <RwandaAdminViewPolicy />
                        },
                        {
                            path: 'viewquotation/:quoteId',
                            element: <ViewQuoteDetails />
                        }
                    ]
                },
                {
                    path: 'generated-quotes',
                    element: <Quotes />
                },
                {
                    path: 'generate-quote',
                    element: <GenerateQuote />
                },
                {
                    path: 'generate-quote-rw',
                    element: <GenerateQuoteRwanda />
                }
            ]
        },
        {
            path: 'products',
            children: [
                {
                    path: 'travel',
                    children: [
                        {
                            path: 'setup',
                            children: [
                                {
                                    path: '',
                                    element: <TravelSetup />
                                },
                                {
                                    path: 'plan',
                                    element: <TravelPlanBenefits />
                                },
                                {
                                    path: 'plan/:planID',
                                    element: <TravelPlanBenefits />
                                }
                            ]
                        },
                        {
                            path: 'reports',
                            element: <AdminCompletedTransactions />
                        }
                    ]
                }
            ]
        },
        {
            path: 'users',
            children: [
                {
                    path: 'management',
                    element: <UsersManagement />
                }
            ]
        },
        {
            path: 'agencies',
            children: [
                {
                    path: '',
                    element: <BritamAdminAgencies />
                },
                {
                    path: 'agency',
                    element: <BritamAdminAgency />
                },
                {
                    path: 'agency/:agencyId',
                    element: <BritamAdminAgency />
                }
            ]
        },
        {
            path: 'settings',
            element: <Settings />
        },
        {
            path: 'support',
            element: <BritamAdminSupport />
        }
    ]
};
